import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BzgButtonToggleComponent} from './button-toggle/button-toggle.component';
import {BzgButtonToggleGroupComponent} from './button-toggle-group/button-toggle-group.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [BzgButtonToggleComponent, BzgButtonToggleGroupComponent],
  exports: [BzgButtonToggleComponent, BzgButtonToggleGroupComponent]
})
export class BzgButtonToggleModule { }
